// JavaScript function to handle onload events and register functions
document.addEventListener("DOMContentLoaded", function () {
  initGetSaveJobsData();
  initShowJobsData();
});

document.body.addEventListener("click", function (e) {
  initShareJobDetails(e);
});

function initGetSaveJobsData() {
  // Load saved jobs from Local storage into a Set
  let savedJobsSet = new Set(getSavedJobsFromStorage());
  // Read from PHP-injected global variable
  const toggleEnabled = window.psSavedJobsToggleEnabled === true || window.psSavedJobsToggleEnabled === 1;

  if (!toggleEnabled) {
    // Remove all save-job buttons
    document.querySelectorAll(".save-job-btn").forEach(btn => btn.remove());
  } else {
    // On page load, mark saved buttons as filled
    document.querySelectorAll(".save-job-btn").forEach(btn => {
      const jobId = btn.getAttribute("data-job-id");
      if (savedJobsSet.has(jobId)) {
        const svg = btn.querySelector("svg");
        btn.setAttribute("aria-label", "Job saved");
        btn.setAttribute("title", "Job saved");
        btn.setAttribute("href", "/saved-jobs");
        if (svg) svg.classList.add("filled");
      }
    });
  }

  // Delegate click handler on document body
  document.body.addEventListener("click", function (e) {
    const target = e.target.closest(".save-job-btn");
    if (!target) return;

    const jobId = target.getAttribute("data-job-id");
    const href = target.getAttribute("href");

    // Only prevent default if the job isn't saved yet (not navigating to /saved-jobs)
    const isAlreadySaved = savedJobsSet.has(jobId);
    const isNavigatingToSavedJobs = href === "/saved-jobs";

    if (!isNavigatingToSavedJobs) {
      e.preventDefault();
    }

    if (!isAlreadySaved) {
      savedJobsSet.add(jobId);
      target.setAttribute("href", "/saved-jobs");

      const svg = target.querySelector("svg");
      if (svg) {
        svg.classList.add("filled");
      }

      // Accessibility updates
      target.setAttribute("aria-label", "Job saved");
      target.setAttribute("title", "Job saved");

      updateSavedJobsInStorage(Array.from(savedJobsSet));

      // ajax request for update in database
      fetch(window.psSavedJobsData.ajax_url, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          action: "increment_saved_job_count",
          job_id: jobId,
        }),
      })
        .then(response => response.json())
        .then(data => {
        })
        .catch(error => {
        });

    } else {
      // Optional: update accessibility attributes for already-saved case
      target.setAttribute("aria-label", "Job already saved");
      target.setAttribute("title", "Job already saved");
    }
  });

  function getSavedJobsFromStorage() {
    const data = localStorage.getItem("saved_jobs");
    return data ? JSON.parse(data) : [];
  }
  function updateSavedJobsInStorage(jobsArray) {
    localStorage.setItem("saved_jobs", JSON.stringify(jobsArray));
  }
}
function initShowJobsData() {
  const loadMoreBtn = document.getElementById("load-more-btn");
  const savedJobsContainer = document.getElementById("saved-jobs-container");
  let offset = 0;
  let savedJobs = JSON.parse(localStorage.getItem("saved_jobs") || "[]");
  let totalJobs = savedJobs.length;

  function updateSavedJobsInStorage(jobsArray) {
    localStorage.setItem("saved_jobs", JSON.stringify(jobsArray));
  }
  if (savedJobsContainer) {
    let pendingConfirmation = null; // Track the button waiting for confirmation

    document.addEventListener("click", function (e) {
      const removeBtn = e.target.closest(".remove-job-btn");

      // If user clicked outside any pending confirmation
      if (pendingConfirmation && (!removeBtn || removeBtn !== pendingConfirmation)) {
        hideTooltip(pendingConfirmation);
        pendingConfirmation = null;
        return;
      }

      // If clicked a remove button
      if (removeBtn) {
        // First click: show tooltip
        if (pendingConfirmation !== removeBtn) {
          showTooltip(removeBtn, "  Are you sure you want to delete this job?");
          pendingConfirmation = removeBtn;
        } else {
          // Second click: confirm delete
          const jobItem = removeBtn.closest(".job-item");
          const jobId = jobItem.getAttribute("data-job-id");

          jobItem.remove();
          savedJobs = savedJobs.filter(id => id.toString() !== jobId);
          updateSavedJobsInStorage(savedJobs);
          totalJobs = savedJobs.length;

          if (loadMoreBtn && offset < totalJobs) {
            loadMoreBtn.style.display = "block";
          }

          hideTooltip(removeBtn);
          pendingConfirmation = null;
        }
      }
    });

    function showTooltip(button, message) {
      // Remove existing tooltip if any
      hideTooltip(button);

      const tooltip = document.createElement("div");
      tooltip.className = "custom-tooltip";
      tooltip.innerHTML = `
    <div class="tooltip-content"><p>${message}</p></div>
    <div class="tooltip-arrow"></div>
  `;

      tooltip.style.position = "absolute";
      tooltip.style.top = "-43px"; // adjust for height
      tooltip.style.right = "-4px";
      tooltip.style.zIndex = "1000";
      tooltip.setAttribute("data-tooltip", "true");

      button.parentNode.style.position = "relative"; // Ensure positioning works
      button.parentNode.appendChild(tooltip);
    }


    function hideTooltip(button) {
      const tooltip = button.parentNode.querySelector("[data-tooltip]");
      if (tooltip) tooltip.remove();
    }
  }


  function getSaveJobsData() {
    fetch(`${window.psSavedJobsData.ajax_url}?action=ps_load_more_jobs&offset=${offset}&saved_jobs=${encodeURIComponent(JSON.stringify(savedJobs))}`)
      .then(res => res.text())
      .then(data => {
        if (data.trim()) {
          if (savedJobsContainer) {
            savedJobsContainer.innerHTML = data;
          }
          offset += 6;
          if (offset >= totalJobs && loadMoreBtn) {
            loadMoreBtn.style.display = "none";
          }
        } else {
          if (loadMoreBtn) {
  loadMoreBtn.style.display = "none"; // or "block"
}

        }
      });
  }

  // Load More
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", function () {
      fetch(`${window.psSavedJobsData.ajax_url}?action=ps_load_more_jobs&offset=${offset}&saved_jobs=${encodeURIComponent(JSON.stringify(savedJobs))}`)
        .then(res => res.text())
        .then(data => {
          if (data.trim()) {
            savedJobsContainer.insertAdjacentHTML('beforeend', data);
            offset += 6;
            if (offset >= totalJobs && loadMoreBtn) {
              loadMoreBtn.style.display = "none";
            }
          } else {
            if (loadMoreBtn) {
  loadMoreBtn.style.display = "none"; // or "block"
}

          }
        });
    });
  }

  if (offset >= totalJobs && loadMoreBtn) {
    loadMoreBtn.style.display = "none";
  }
  getSaveJobsData();
}

function initShareJobDetails(e) {
  const target = e.target.closest(".ps-share-job-description");
  if (!target) return;
  e.preventDefault();
  const shareData = {
    title: document.title,
    text: "Check out this job description!",
    url: window.location.href
  };

  if (navigator.share) {
    navigator.share(shareData)
      .then(() => console.log("Job description shared successfully"))
      .catch((err) => console.error("Error sharing:", err));
  } else {
    alert("Sharing not supported on this browser.");
  }
}

